import { CSSProperties } from 'react';

export interface AnimatedEllipsisProps {
  size?: 'sm' | 'md' | 'lg';
}

export function AnimatedEllipsis({ size = 'md' }: AnimatedEllipsisProps) {
  const styles = {
    '--dot-size':
      size === 'sm' ? '0.8rem' : size === 'md' ? '1.2rem' : '1.8rem',
    '--dot-gap': size === 'sm' ? '0.4rem' : size === 'md' ? '0.8rem' : '1rem',
  } as CSSProperties;

  return (
    <div className="animated-ellipsis" style={styles}>
      <div />
      <div />
      <div />
      <div />
    </div>
  );
}
